// extracted by mini-css-extract-plugin
export default {"roadCard":"RoadCard_roadCard__RTPCh","num":"RoadCard_num__A1uo5","future":"RoadCard_future__02KZV"};